import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './MemoryGame.css';

const CARD_SYMBOLS = ['🎈', '🎯', '🎨', '🎪', '🎭', '🎸', '🎺', '🎻'];

const MemoryGame = () => {
  const [cards, setCards] = useState([]);
  const [flippedCards, setFlippedCards] = useState([]);
  const [matchedCards, setMatchedCards] = useState([]);
  const [moves, setMoves] = useState(0);
  const [gameWon, setGameWon] = useState(false);

  const initializeGame = () => {
    const shuffledCards = [...CARD_SYMBOLS, ...CARD_SYMBOLS]
      .sort(() => Math.random() - 0.5)
      .map((symbol, index) => ({
        id: index,
        symbol,
        isFlipped: false,
        isMatched: false
      }));
    
    setCards(shuffledCards);
    setFlippedCards([]);
    setMatchedCards([]);
    setMoves(0);
    setGameWon(false);
  };

  useEffect(() => {
    initializeGame();
  }, []);

  useEffect(() => {
    if (flippedCards.length === 2) {
      const [first, second] = flippedCards;
      setMoves(prev => prev + 1);
      
      if (cards[first].symbol === cards[second].symbol) {
        setMatchedCards(prev => [...prev, first, second]);
        setFlippedCards([]);
      } else {
        setTimeout(() => {
          setFlippedCards([]);
        }, 1000);
      }
    }
  }, [flippedCards, cards]);

  useEffect(() => {
    if (matchedCards.length === cards.length && cards.length > 0) {
      setGameWon(true);
    }
  }, [matchedCards, cards]);

  const handleCardClick = (index) => {
    if (flippedCards.length === 2 || 
        flippedCards.includes(index) || 
        matchedCards.includes(index)) {
      return;
    }
    
    setFlippedCards(prev => [...prev, index]);
  };

  const isCardVisible = (index) => {
    return flippedCards.includes(index) || matchedCards.includes(index);
  };

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">🃏 Memory Game</h1>
        <div className="game-instructions">
          Click cards to flip them. Match pairs to win. Try to complete in fewer moves!
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">
          Moves: {moves}
          {gameWon && <div style={{color: 'green'}}>🎉 You Won!</div>}
        </div>
        
        <div className="game-play-area">
          <div className="memory-board">
            {cards.map((card, index) => (
              <div
                key={card.id}
                className={`memory-card ${isCardVisible(index) ? 'flipped' : ''}`}
                onClick={() => handleCardClick(index)}
              >
                <div className="card-front">?</div>
                <div className="card-back">{card.symbol}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="game-controls">
          <button className="btn btn-primary" onClick={initializeGame}>
            New Game
          </button>
          <Link to="/" className="btn btn-secondary">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MemoryGame;